import { GET_NDHM_HOST } from "../../constants/env";
import fetch from "../../fetch-client";
import {
  NDHMGenericApiResponse,
  TPostLinkHealthFacilityParam,
} from "../../types/axon";


type LinkedService = {
  id: string;
  name: string;
  types: string[] | null;
  active: boolean;
};

type LinkFacilityError = {
  code: string;
  message: string;
};

type LinkHealthFacilityResponseData = {
  servicesLinked: LinkedService;
  error?: LinkFacilityError;
};


export default async function postLinkHealthFacility({
  clinicId,
  hfrId,
  doctorId,
}: TPostLinkHealthFacilityParam): Promise<
  NDHMGenericApiResponse<LinkHealthFacilityResponseData>
> {
  try {
    const NDHM_HOST = GET_NDHM_HOST();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const body = JSON.stringify({
      clinic_id: clinicId,
      hfr_id: hfrId,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body,
      mode: "cors",
      credentials: "include",
    };
    const response = await fetch(
      `${NDHM_HOST}/abdm/nhpr/v1/hfr/link?doctor_oid=${doctorId}`,
      requestOptions,
    );
    return await response.json();
  } catch (error) {
    return { success: false };
  }
}
